import BreadCrumb from "Components/Common/BreadCrumb";
import { extractFieldErrors } from "common/lib/fieldErrors";
import { addLOA, getRequestTypes } from "common/services/govt-requests.service";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import * as Yup from "yup";
import LOAForm from "./LOAForm";

const AddLOA = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<any>([]);
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      requestTitle: "",

      noOfPositionsRequested: "",
      positionTitle: "",

      requestedSalary: null,
      totalValueOfRequest: null,
      periodInMonths: "",
      dateOfRequest: "",
      startDate: "",
      endDate: "",
      documentAttachments: [],
      fundingStatus: "",
      reviewOfRequest: "",
      agency: {
        value: "",
        label: "",
      },
      region: {
        value: "",
        label: "",
      },
      mda: {
        value: "",
        label: "",
      },

      additionalDetails: "",

      selectedFiles: [],
    },
    validationSchema: Yup.object({
      requestTitle: Yup.string().required("Please enter request title"),
      noOfPositionsRequested: Yup.number(),
      positionTitle: Yup.string(),

      requestedSalary: Yup.number().nullable(),
      totalValueOfRequest: Yup.number().required("Please enter total value"),
      periodInMonths: Yup.number().nullable(),
      startDate: Yup.date().nullable(),

      endDate: Yup.date().nullable(),
      dateOfRequest: Yup.date().required("Please select date of request"),
      fundingStatus: Yup.string(),
      reviewOfRequest: Yup.string(),
      agency: Yup.object().shape({
        value: Yup.string().required("Please select agency"),
      }),
      region: Yup.object().shape({
        value: Yup.string().required("Please select region"),
      }),
      mda: Yup.object().shape({
        value: Yup.string().required("Please select MDA"),
      }),

      additionalDetails: Yup.string(),
      selectedFiles: Yup.array(),
      // .min(1, "Atleast one file is required")
      // .required("Required"),
    }),
    onSubmit: async (values: any) => {
      try {
        let data = {};
        const requestTypeResponse = await getRequestTypes({
          filters: {
            code: "Other",
          },
        });
        const requestTypeId = requestTypeResponse?.data[0];

        data = {
          requestTitle: values?.requestTitle || null,
          typeOfRequest: requestTypeId || null,
          requestDescription: values?.requestDescription || null,
          noOfPositionsRequested: `${values?.noOfPositionsRequested}` || null,
          positionTitle: values?.positionTitle || null,
          requestedSalary: values?.requestedSalary || null,
          totalValueOfRequest: values?.totalValueOfRequest || null,
          periodInMonths: values?.periodInMonths?.toString() || null,
          dateOfRequest:
            (values?.dateOfRequest &&
              values?.dateOfRequest?.toLocaleDateString("en-CA")) ||
            null,
          startDate:
            (values?.startDate &&
              values.startDate?.toLocaleDateString("en-CA")) ||
            null,
          endDate:
            (values?.endDate && values?.endDate?.toLocaleDateString("en-CA")) ||
            null,
          contactPerson: null,
          fundingStatus: values?.fundingStatus || null,
          reviewOfRequest: values?.reviewOfRequest || null,
          agency: values?.agency?.value || null,
          region: values?.region?.value || null,
          mda: values?.mda?.value || null,
          entity: values?.entity?.label || null,
          positionType: values?.positionType?.value || null,
          formOfGovernmentRequest: null,
          nameOfRequester: null,
          objectiveOfRequest: null,
          expectedOutputs: null,
          additionalDetails: values?.additionalDetails || null,
          isLOA: true,
        };

        const formData = new FormData();
        values.selectedFiles.forEach((file: any) => {
          formData.append("files.documentAttachments", file, file.name);
        });
        formData.append("data", JSON.stringify(data));

        setLoading(true);
        await addLOA(formData);
        // navigate("/government-requests/" + response?.payload?.data?.id);
        navigate("/loas");
      } catch (error: any) {
        const errors = extractFieldErrors(error?.response);
        setFieldErrors(errors);
      } finally {
        setLoading(false);
      }
    },
  });

  const startDateValue = validation.values?.startDate;
  const endDateValue = validation.values?.endDate;
  const setFieldValue = validation.setFieldValue;

  useEffect(() => {
    if (startDateValue && endDateValue) {
      const startDate = new Date(startDateValue);
      const endDate = new Date(endDateValue);
      const monthDifference =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());
      setFieldValue("periodInMonths", monthDifference);
    }
  }, [endDateValue, setFieldValue, startDateValue]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Add LOA"
          pageTitles={[
            {
              title: "Dashboard",
              link: "/",
            },
            { title: "LOAs", link: "/loas" },
          ]}
          back
        />
        <LOAForm
          validation={validation}
          isUpdate={false}
          loading={loading}
          fieldErrors={fieldErrors}
        />
      </Container>
    </div>
  );
};

export default AddLOA;
